import React, { useState, useEffect } from 'react';
import { usePermissions } from '../../../hooks/usePermissions';
import UsersTab from './UsersTab';
import RolesTab from './RolesTab';
import PoliciesTab from './PoliciesTab';
import './RBAC.css';
import PageHeader from '../../common/PageHeader/PageHeader';

export default function AuthorizationManagement() {
  const { hasPermission } = usePermissions();
  const [activeTab, setActiveTab] = useState('users');
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Define tabs with their permission requirements
  const tabs = [
    { id: 'users', label: 'Users', resource: 'users', action: 'list' },
    { id: 'roles', label: 'Roles', resource: 'user_roles', action: 'read' },
    { id: 'policies', label: 'Policies', resource: 'user_roles', action: 'read' }
  ];

  // Filter tabs based on permissions
  const visibleTabs = tabs.filter(tab => 
    hasPermission(tab.resource, tab.action)
  );

  // Ensure active tab is visible, switch to first visible if not
  useEffect(() => {
    if (visibleTabs.length > 0 && !visibleTabs.find(tab => tab.id === activeTab)) {
      setActiveTab(visibleTabs[0].id);
    }
  }, [visibleTabs, activeTab]);

  // Trigger refresh of current tab
  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  // Handle tab change
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="page-container authorization-management">
      <div>
        <PageHeader
          title="Authorization Management"
          description="Manage users, roles, and policies for your organization."
          icon="fas fa-user-shield"
          accentColor="blue"
        />
        
        <div className="rbac-container">
          <div className="rbac-tabs">
          {visibleTabs.map(tab => (
            <button
              key={tab.id}
                className={`rbac-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => handleTabChange(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

          <div className="rbac-content">
          {activeTab === 'users' && (
            <UsersTab 
              key={`users-${refreshTrigger}`}
              onRefresh={handleRefresh}
            />
          )}
          {activeTab === 'roles' && (
            <RolesTab 
              key={`roles-${refreshTrigger}`}
              onRefresh={handleRefresh}
            />
          )}
          {activeTab === 'policies' && (
            <PoliciesTab 
              key={`policies-${refreshTrigger}`}
            />
          )}
          </div>
        </div>
      </div>
    </div>
  );
}
